import { useTranslation } from 'react-i18next'

import CustomerMessage from '@entities/User/ui/profile/customer-message'
import styles from '@entities/User/ui/profile/styles.module.scss'

import { useModalStore } from '@features/modal'




export default function useCustomerMessage () {
  const { openModal, closeModal } = useModalStore()
  const { t: tu } = useTranslation('user')

  const openCustomerMessage = () => {
    openModal('customerMessage', <CustomerMessage />, {
      title: tu('customerRegister.title'),
      description: tu('customerRegister.description'),
      classes: {
        content: styles['modal-content'],
      },
    })
  }

  const closeCustomerMessage = () => {
    closeModal('customerMessage')
  }

  return {
    openCustomerMessage,
    closeCustomerMessage,
  }
}
